<template>
<div>
  <el-form size="small" style="margin-right: 30px" :model="addEditBasicForm" :rules="addEditBasicRules" ref="addEditBasicForm" label-width="110px" class="demo-ruleForm">
    <el-row>
      <el-col :span="16">
        <el-col :span="12">
          <el-form-item label="老人姓名" prop="elderly_name">
            <el-input v-model="addEditBasicForm.elderly_name" placeholder="请输入老人姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="gender">
            <el-select v-fixZoom v-model="addEditBasicForm.gender" filterable placeholder="请选择" style="width: 100%">
              <el-option v-for="item in genderArr" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出生日期" prop="birth_date">
            <el-date-picker v-fixZoom style="width: 100%" v-model="addEditBasicForm.birth_date"
                            type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" prop="id_number">
            <el-input v-model="addEditBasicForm.id_number" placeholder="请输入身份证号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="">
            <el-input type="number" v-model="addEditBasicForm.contact_phone_number" placeholder="请输入联系电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="移动电话" prop="">
            <el-input type="number" v-model="addEditBasicForm.mobile_phone_number" placeholder="请输入移动电话"></el-input>
          </el-form-item>
        </el-col>
      </el-col>
      <el-col :span="8">
        <div style="width: 90px;margin: auto">
          <el-upload class="avatar-uploader" action="#" :auto-upload="false"
            :show-file-list="false" :on-exceed="handleExceed" :before-upload="beforeUpload"
            :on-change="getFile" list-type="picture" :file-list="fileList" ref="uploadavatar">
            <img v-if="addEditBasicForm.elderly_photo" :src="addEditBasicForm.elderly_photo" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div style="font-size: 16px;text-align: center;color: #409EFF">
          <span v-if="isAddPerson">上传头像</span>
          <span v-if="!isAddPerson">更新头像</span>
        </div>
        <div style="font-size: 14px;text-align: center;color: #999999"><span>jpeg/jpg/png格式</span></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-form-item label="籍贯" prop="">
          <el-input v-model="addEditBasicForm.place_of_origin" placeholder="请输入籍贯"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="民族" prop="">
          <el-select v-fixZoom v-model="addEditBasicForm.nationality" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in nationOptions" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="婚姻状况" prop="">
          <el-radio-group v-model="addEditBasicForm.marital_status">
            <el-radio label="2">已婚</el-radio>
            <el-radio label="1">未婚</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="配偶" prop="">
          <el-input v-model="addEditBasicForm.mate_name" placeholder="请输入配偶姓名"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="结婚纪念日" prop="">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditBasicForm.married_date"
                          type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item label="现居住地" prop="residential_address">
          <el-input autosize placeholder="请输入现居住地" v-model="addEditBasicForm.residential_address"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="现住址邮编" prop="">
          <el-input v-model="addEditBasicForm.residential_postal_code" placeholder="请输入现住址邮编"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="政治面貌" prop="">
          <el-select v-fixZoom v-model="addEditBasicForm.political_status" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in politicalArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="宗教" prop="">
          <el-select v-fixZoom v-model="addEditBasicForm.religion" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in religionArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="文化程度" prop="">
          <el-select v-fixZoom v-model="addEditBasicForm.educational_level" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in educationArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="专业" prop="">
          <el-input v-model="addEditBasicForm.profession" placeholder="请输入专业"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="职业" prop="">
          <el-input v-model="addEditBasicForm.career" placeholder="请输入职业"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="老年证号" prop="">
          <el-input placeholder="请输入老年证号" v-model="addEditBasicForm.old_person_card"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="户籍性质" prop="household_type">
          <el-select v-fixZoom v-model="addEditBasicForm.household_type" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in householdArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item label="照护等级" prop="">
          <el-select v-fixZoom v-model="addEditBasicForm.elderly_care_level" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in careLevelArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item label="户籍所在地" prop="household_address">
          <el-input placeholder="请输入户籍所在地" v-model="addEditBasicForm.household_address"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="户籍地邮编" prop="">
          <el-input v-model="addEditBasicForm.household_postal_code" placeholder="请输入户籍地邮编"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="basicObj.isAwait" style="border-top: 1px solid #cccccc;padding-top: 10px">
      <el-col :span="8">
        <el-form-item label="计划入住日期" prop="">
<!--          <el-input v-model="addEditBasicForm.household_postal_code" placeholder="请输入户籍地邮编"></el-input>-->
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="定金" prop="">
          <el-input type="number" placeholder="定金（元）"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="接待人姓名" prop="">
          <el-input placeholder="请输入接待人姓名"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 40px;">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div v-if="basicObj.isAwait" class="send-btn" @click="submitAddEdit('addEditBasicForm')">
          <span v-if="isAdd">新增</span>
          <span v-else>更新</span>
        </div>
        <div v-else class="send-btn" @click="submitAddEditUnit('addEditBasicForm')">
          <span v-if="isAdd">确定新增</span>
          <span v-else>确定更新</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {createelderly, updateelderly, uploadfile} from '../../../api/yanglaoyuan'
export default {
  name: 'basicInfo',
  props: {
    basicObj: {
      type: Object,
      default: null
    }
  },
  data () {
    const validateIdCard = (rule, value, callback) => {
      const sfz = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value !== '') {
        if (!sfz.test(value)) {
          callback(new Error('身份证输入格式不正确'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入身份证号'))
      }
    }
    return {
      // entityelderlyservice: '',
      oldPersonRow: '',
      nationOptions: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      genderArr: [
        // {id: 0, name: '未知性别'},
        {id: '1', name: '男性'},
        {id: '2', name: '女性'}
        // {id: 9, name: '未说明性别'}
      ],
      politicalArr: [],
      educationArr: [],
      religionArr: [
        {id: '1', name: '无'},
        {id: '2', name: '佛教'},
        {id: '3', name: '道教'},
        {id: '4', name: '伊斯兰教'},
        {id: '5', name: '基督教'},
        {id: '6', name: '天主教'},
        {id: '7', name: '其他宗教'},
        {id: '9', name: '不详'}
      ],
      householdArr: [],
      careLevelArr: [],
      addEditBasicForm: { // 25
        id: 0,
        elderly_name: '',
        e_id: 0,
        gender: '',
        nationality: '',
        id_number: '',
        contact_phone_number: '',
        mobile_phone_number: '',
        place_of_origin: '',
        marital_status: '',
        residential_address: '',
        residential_postal_code: '',
        birth_date: '',
        religion: '',
        educational_level: '',
        household_type: '',
        elderly_care_level: '',
        household_address: '',
        household_district_code: '',
        elderly_photo: '',
        photoid: '',
        extra_info: {},
        // 基本信息
        mate_name: '',
        married_date: '',
        political_status: '',
        profession: '',
        career: '',
        old_person_card: ''
      },
      addEditBasicRules: {
        elderly_name: [{required: true, message: '请输入老人姓名', trigger: 'blur'}],
        e_id: [{required: true, message: '请选择所属机构', trigger: 'change'}],
        gender: [{required: true, message: '请选择性别', trigger: 'change'}],
        nationality: [{required: true, message: '请选择民族', trigger: 'change'}],
        id_number: [{ required: true, trigger: 'blur', validator: validateIdCard }],
        marital_status: [{required: true, message: '请选择婚姻状况', trigger: 'change'}],
        birth_date: [{required: true, message: '请选择出生日期', trigger: 'change'}],
        religion: [{required: true, message: '请选择宗教', trigger: 'change'}],
        household_type: [{required: true, message: '请选择户籍性质', trigger: 'change'}],
        elderly_care_level: [{required: true, message: '请选择护理级别', trigger: 'change'}],
        residential_address: [{required: true, message: '请输入现居住地', trigger: 'blur'}],
        household_address: [{required: true, message: '请输入户籍所在地', trigger: 'blur'}]
      },
      // 头像
      fileList: [],
      isAddPerson: true,
      imageUrl: '',
      isAdd: true
    }
  },
  created () {
    this.nationOptions = this.commonType.getNationName()
    this.educationArr = this.commonType.getEducationArr()
    this.householdArr = this.commonType.getHouseholdArr()
    this.careLevelArr = this.commonType.getCareLevelArr()
    this.politicalArr = this.commonType.getPoliticalArr()
    this.oldPersonRow = this.basicObj.oldPersonRow
    this.isAdd = this.basicObj.isAdd
    this.addEditBasicForm.e_id = this.$store.state.user.LoginResp.entity_id
    if (this.basicObj.isAwait) { // 轮候登记 页面
    } else { // 老人档案 页面
      if (this.basicObj.isAdd) {
        if (this.basicObj.isBtn) { // 接口添加之后编辑 弃
          this.isAdd = false
          this.getStartBasic()
        }
      } else { // 表格 详情 按钮
        this.getStartBasic()
      }
    }
  },
  methods: {
    getStartBasic () {
      let info = null
      if (this.oldPersonRow.extra_info && this.oldPersonRow.extra_info !== '') {
        info = JSON.parse(this.oldPersonRow.extra_info)
      }
      this.addEditBasicForm = this.commonType.getOldPersonForm(this.oldPersonRow, info)
    },
    // 头像
    beforeUpload (file) {
      console.log(111, file, file.type)
    },
    getFile (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '头像',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传', type: 'success' })
        this.addEditBasicForm.photoid = res.data.fileid
        this.addEditBasicForm.elderly_photo = res.data.fileurl
      }).catch(() => {
        this.$message.closeAll()
        this.imageUrl = ''
        this.$message({ message: '上传失败', type: 'error' })
      })
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    closeAddEdit () {
      this.$emit('changeEndBasic', {type: 'close'})
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.commonType.getJsonInfo(this.addEditBasicForm)
          if (this.isAdd) {
            createelderly(data).then(res => {
              this.isAdd = false
              this.addEditBasicForm.id = res.data.id
              this.$notify({title: '成功', message: '成功新增老人', type: 'success', duration: 2000})
              let obj = {
                type: 'isBtnBasic',
                addEditBasicForm: this.addEditBasicForm,
                extra_info: data.extra_info
              }
              this.$emit('changeEndBasic', obj)
            }).catch(() => {})
          } else {
            updateelderly(data).then(res => {
              let obj = {
                type: 'isBtnBasic',
                addEditBasicForm: this.addEditBasicForm,
                extra_info: data.extra_info
              }
              this.$emit('changeEndBasic', obj)
              this.$notify({title: '成功', message: '成功编辑老人', type: 'success', duration: 2000})
            }).catch(() => {})
          }
        }
      })
    },
    // 轮候登记
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/basicInfo.vue